<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="6"
            align="center"
          >
            <template>
              <v-img
                :src="'/storage/' + app.logo"
                :lazy-src="'/storage/' + app.logo"
                class="mb-5"
                :max-width="app.logoWidth"
                :max-height="app.logoHight"
              />
            </template>
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      app: "configs/overall",
    }),
  },
};
</script>
